import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  user: any;

  constructor(private userService: UserService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    return this.userService.getUserProfile().pipe(
      map(user => {
        return (user) ? ['DH'].indexOf(user.platform) > -1 : false;
      }),
      catchError((err) => {
        return of(false);
      })
    );
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.userService.getUserProfile().pipe(
      map(user => {
        return (user) ? user.profile.links[next.routeConfig.path] !== undefined : false;
      }),
      catchError((err) => {
        return of(false);
      })
    );
  }

}
